<template>
    <router-view />
</template>

<script>
export default {
    name: 'Lean-Layout'
}
</script>